export default __webpack_public_path__ + "static/media/side.223473ce.jpeg";